import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import PartyDashboard from 'components/party/PartyDashboard';
import PartyPage from 'components/party/page/PartyPage';
import ProductDashboard from 'components/product/ProductDashboard';
import ProductPage from 'components/product/page/ProductPage';
import CompositionDashboard from 'components/composition/CompositionDashboard';
import CompositionPage from 'components/composition/page/CompositionPage';
import ProductcompositionDashboard from 'components/productcomposition/ProductcompositionDashboard';
import ProductcompositionPage from 'components/productcomposition/page/ProductcompositionPage';
import PoDashboard from 'components/po/PoDashboard';
import PoPage from 'components/po/page/PoPage';
import OrderpomappingDashboard from 'components/orderpomapping/OrderpomappingDashboard';
import OrderpomappingPage from 'components/orderpomapping/page/OrderpomappingPage';
import PharmaorderDashboard from 'components/pharmaorder/PharmaorderDashboard';
import PharmaorderPage from 'components/pharmaorder/page/PharmaorderPage';
import PhpackagingmaterialDashboard from 'components/phpackagingmaterial/PhpackagingmaterialDashboard';
import PhpackagingmaterialPage from 'components/phpackagingmaterial/page/PhpackagingmaterialPage';
import DesignvendorDashboard from 'components/designvendor/DesignvendorDashboard';
import DesignvendorPage from 'components/designvendor/page/DesignvendorPage';
import PhproductformDashboard from 'components/phproductform/PhproductformDashboard';
import PhproductformPage from 'components/phproductform/page/PhproductformPage';
import PhproductDashboard from 'components/phproduct/PhproductDashboard';
import PhproductPage from 'components/phproduct/page/PhproductPage';
import PhproductstatusDashboard from 'components/phproductstatus/PhproductstatusDashboard';
import PhproductstatusPage from 'components/phproductstatus/page/PhproductstatusPage';
import PhproductshapeDashboard from 'components/phproductshape/PhproductshapeDashboard';
import PhproductshapePage from 'components/phproductshape/page/PhproductshapePage';
import PhdesignDashboard from 'components/phdesign/PhdesignDashboard';
import PhdesignPage from 'components/phdesign/page/PhdesignPage';
import ProductassetDashboard from 'components/productasset/ProductassetDashboard';
import ProductassetPage from 'components/productasset/page/ProductassetPage';
import RmunitDashboard from 'components/rmunit/RmunitDashboard';
import RmunitPage from 'components/rmunit/page/RmunitPage';
import RawmaterialDashboard from 'components/rawmaterial/RawmaterialDashboard';
import RawmaterialPage from 'components/rawmaterial/page/RawmaterialPage';
import ProductrawDashboard from 'components/productraw/ProductrawDashboard';
import ProductrawPage from 'components/productraw/page/ProductrawPage';
import RawdemandDashboard from 'components/rawdemand/RawdemandDashboard';
import RawdemandPage from 'components/rawdemand/page/RawdemandPage';
import ProductrawtorawdemandDashboard from 'components/productrawtorawdemand/ProductrawtorawdemandDashboard';
import ProductrawtorawdemandPage from 'components/productrawtorawdemand/page/ProductrawtorawdemandPage';
import RmvendorDashboard from 'components/rmvendor/RmvendorDashboard';
import RmvendorPage from 'components/rmvendor/page/RmvendorPage';
import RmvendorquotationDashboard from 'components/rmvendorquotation/RmvendorquotationDashboard';
import RmvendorquotationPage from 'components/rmvendorquotation/page/RmvendorquotationPage';
import CompositiontemplateDashboard from 'components/compositiontemplate/CompositiontemplateDashboard';
import CompositiontemplatePage from 'components/compositiontemplate/page/CompositiontemplatePage';
import CtitemDashboard from 'components/ctitem/CtitemDashboard';
import CtitemPage from 'components/ctitem/page/CtitemPage';
import PharmaorderPageEditProduct from 'components/pharmaorder/page/PharmaorderPageEditProduct';
import PackagingsizeDashboard from 'components/packagingsize/PackagingsizeDashboard';
import PharmasetDashboard from 'components/pharmaset/PharmasetDashboard';
import PartystatusDashboard from 'components/partystatus/PartystatusDashboard';
import DesignerProductPage from 'components/product/page/DesignerProductPage';
import QaProductPage from 'components/product/page/QaProductPage';
import SaltPage from 'components/salt/page/SaltPage';
import GstPage from 'components/gst/page/GstPage';


// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/SamplePage')));

// render - utilities
const Typography = Loadable(lazy(() => import('pages/components-overview/Typography')));
const Color = Loadable(lazy(() => import('pages/components-overview/Color')));
const Shadow = Loadable(lazy(() => import('pages/components-overview/Shadow')));
const AntIcons = Loadable(lazy(() => import('pages/components-overview/AntIcons')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },

    {path: '/party',element: <PartyDashboard />},
{path: '/partypage',element: <PartyPage />},
{path: '/product',element: <ProductDashboard />},
{path: '/productpage',element: <ProductPage />},
{path: '/composition',element: <CompositionDashboard />},
{path: '/compositionpage',element: <CompositionPage />},
{path: '/productcomposition',element: <ProductcompositionDashboard />},
{path: '/productcompositionpage',element: <ProductcompositionPage />},
{path: '/po',element: <PoDashboard />},
{path: '/popage',element: <PoPage />},
{path: '/orderpomapping',element: <OrderpomappingDashboard />},
{path: '/orderpomappingpage',element: <OrderpomappingPage />},
{path: '/pharmaorder',element: <PharmaorderDashboard />},
{path: '/pharmaorderpage',element: <PharmaorderPage />},
{path: '/phpackagingmaterial',element: <PhpackagingmaterialDashboard />},
{path: '/phpackagingmaterialpage',element: <PhpackagingmaterialPage />},
{path: '/designvendor',element: <DesignvendorDashboard />},
{path: '/designvendorpage',element: <DesignvendorPage />},
{path: '/phproductform',element: <PhproductformDashboard />},
{path: '/phproductformpage',element: <PhproductformPage />},
{path: '/phproduct',element: <PhproductDashboard />},
{path: '/phproductpage',element: <PhproductPage />},
{path: '/phproductstatus',element: <PhproductstatusDashboard />},
{path: '/phproductstatuspage',element: <PhproductstatusPage />},
{path: '/phproductshape',element: <PhproductshapeDashboard />},
{path: '/phproductshapepage',element: <PhproductshapePage />},
{path: '/phdesign',element: <PhdesignDashboard />},
{path: '/phdesignpage',element: <PhdesignPage />},
{path: '/productasset',element: <ProductassetDashboard />},
{path: '/productassetpage',element: <ProductassetPage />},
{path: '/rmunit',element: <RmunitDashboard />},
{path: '/rmunitpage',element: <RmunitPage />},
{path: '/rawmaterial',element: <RawmaterialDashboard />},
{path: '/rawmaterialpage',element: <RawmaterialPage />},
{path: '/productraw',element: <ProductrawDashboard />},
{path: '/productrawpage',element: <ProductrawPage />},
{path: '/rawdemand',element: <RawdemandDashboard />},
{path: '/rawdemandpage',element: <RawdemandPage />},
{path: '/productrawtorawdemand',element: <ProductrawtorawdemandDashboard />},
{path: '/productrawtorawdemandpage',element: <ProductrawtorawdemandPage />},
{path: '/rmvendor',element: <RmvendorDashboard />},
{path: '/rmvendorpage',element: <RmvendorPage />},
{path: '/rmvendorquotation',element: <RmvendorquotationDashboard />},
{path: '/rmvendorquotationpage',element: <RmvendorquotationPage />},
{path: '/compositiontemplate',element: <CompositiontemplateDashboard />},
{path: '/compositiontemplatepage',element: <CompositiontemplatePage />},
{path: '/ctitem',element: <CtitemDashboard />},
{path: '/ctitempage',element: <CtitemPage />},

{path: '/pharmaorderpageeditproduct',element: <PharmaorderPageEditProduct />},
{path: '/packagingsize',element: <PackagingsizeDashboard />},
{path: '/pharmaset',element: <PharmasetDashboard />},
{path: '/partystatus',element: <PartystatusDashboard />},
{path: '/designerproductpage',element: <DesignerProductPage />},
{path: '/qaproductpage',element: <QaProductPage />},
{path: '/saltpage',element: <SaltPage />},
{path: '/gstpage',element: <GstPage />},





    {
      path: 'color',
      element: <Color />
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'icons/ant',
      element: <AntIcons />
    }
  ]
};

export default MainRoutes;